module.exports = dibs_buyer_layout;


//////////////////
// WEBPACK FOOTER
// external "dibs_buyer_layout"
// module id = 4252
// module chunks = 64